import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import './HeroCarousel.css';

// =============================================
// CAROUSEL SLIDES — Edit text and image paths
// Drop your images in /public/images/
// =============================================
const SLIDES = [
  {
    id: 1,
    image: '/images/hero-1.jpg',   // ← YOUR IMAGE HERE
    title: 'The Trump Gold Card is Here!',
    body: 'To support the Trump Gold Card initiative, USCIS has published Form I-140G, Immigrant Petition for the Gold Card Program.',
    linkText: 'Learn More',
    linkHref: '/register',
    linkStyle: 'outline',
  },
  {
    id: 2,
    image: '/images/hero-2.jpg',   // ← YOUR IMAGE HERE
    title: 'Unlock Life in America.',
    body: 'The Gold Card grants lawful permanent residence and work authorization. Apply for yourself or your family today.',
    linkText: 'Apply Now',
    linkHref: '/register',
    linkStyle: 'gold',
  },
  {
    id: 3,
    image: '/images/hero-3.jpg',   // ← YOUR IMAGE HERE
    title: 'Start Your Application.',
    body: 'Create an account, complete Form I-140G, and submit your petition. Our streamlined process guides you every step of the way.',
    linkText: 'Get Started',
    linkHref: '/register',
    linkStyle: 'outline',
  },
];

export default function HeroCarousel() {
  const [current, setCurrent] = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  const goTo = useCallback((index) => {
    if (transitioning) return;
    setTransitioning(true);
    setTimeout(() => {
      setCurrent(index);
      setTransitioning(false);
    }, 300);
  }, [transitioning]);

  const prev = () => goTo((current - 1 + SLIDES.length) % SLIDES.length);
  const next = () => goTo((current + 1) % SLIDES.length);

  // Auto-advance every 6 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      goTo((current + 1) % SLIDES.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [current, goTo]);

  const slide = SLIDES[current];

  return (
    <div className="hero-carousel">
      {/* Slide background */}
      <div
        className={`carousel-bg ${transitioning ? 'fade-out' : 'fade-in'}`}
        style={{ backgroundImage: `url(${slide.image})` }}
        aria-hidden="true"
      />
      {/* Dark overlay for readability */}
      <div className="carousel-overlay" />

      {/* Content */}
      <div className={`carousel-content container ${transitioning ? 'content-out' : 'content-in'}`}>
        <div className="carousel-text">
          <h1 className="carousel-title">{slide.title}</h1>
          <p className="carousel-body">{slide.body}</p>
          <Link
            to={slide.linkHref}
            className={`btn btn-lg carousel-cta ${slide.linkStyle === 'gold' ? 'btn-gold' : 'btn-outline-white'}`}
          >
            {slide.linkText}
          </Link>
        </div>
      </div>

      {/* Prev / Next arrows */}
      <button className="carousel-arrow carousel-arrow-prev" onClick={prev} aria-label="Previous slide">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <path d="M15 18l-6-6 6-6"/>
        </svg>
      </button>
      <button className="carousel-arrow carousel-arrow-next" onClick={next} aria-label="Next slide">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <path d="M9 18l6-6-6-6"/>
        </svg>
      </button>

      {/* Dots */}
      <div className="carousel-dots" role="tablist" aria-label="Slide controls">
        {SLIDES.map((s, i) => (
          <button
            key={s.id}
            className={`carousel-dot ${i === current ? 'active' : ''}`}
            onClick={() => goTo(i)}
            role="tab"
            aria-selected={i === current}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
